<template lang="html">
  <div class="sysmanagement-privilege">
    <div class="page-submenu">
      <div class="page-submenu_left">
        <div class="content-box">
          <left-bar></left-bar>
        </div>
      </div>
      <div class="page-submenu_right">
        <div class="content-box">
          <div class="search-content">
              <div class="search-content-fields">
                  <el-form label-position="top">
                      <el-row>
                          <el-col :span="8">
                              <el-form-item label="员工ID">
                                  <el-input placeholder="请输入员工ID" v-model="searchData.username"></el-input>
                              </el-form-item>
                          </el-col>
                          <el-col :span="8">
                              <el-form-item label="姓名">
                                  <el-input placeholder="请输入姓名" v-model="searchData.realname"></el-input>
                              </el-form-item>
                          </el-col>
                      </el-row>
                      <el-row>
                          <el-col :span="8">
                              <el-form-item label="部门">
                                  <el-select clearable placeholder="请选择" v-model="searchData.departIds">    
                                    <el-option v-for="item in baseDataRecords.Depart" :key="item.id" :value="item.id" :label="item.departName">
                                    </el-option>                                  
                                  </el-select>
                              </el-form-item>
                          </el-col>
                          <el-col :span="8">
                              <el-form-item label="所在治疗领域（franchise）">
                                  <el-select clearable placeholder="请选择" v-model="searchData.medicalField">
                                    <el-option v-for="item in baseDataRecords.MedicalField" :key="item.id" :value="item.id" :label="item.medicalFieldName">
                                    </el-option>
                                  </el-select>
                              </el-form-item>
                          </el-col>
                          <el-col :span="8">
                              <el-form-item>
                                  <el-button type="primary" @click="handleSearch()">搜索</el-button>
                              </el-form-item>
                          </el-col>
                      </el-row>
                  </el-form>                
              </div>
          </div>
          <div class="operate">
            <div>    
              <el-button type="primary" @click="handlerExportExcelClick()" plain>批量导出</el-button>
              <el-button type="primary" @click="handleAddNewClick()" plain>新增用户</el-button>
            </div>
          </div>
          <common-crud ref="crud"
            :addNewOrEditData="addNewOrEditData"
            :searchData="searchData"
            :searchDataLikeField="{'username':'*','realname':'*','roleIds':'*','departIds':'*'}"
            :crudApi="crudApi"
            :tableData.sync="privilegeData"
            :showEditFormTitle="false"
            :beforeSave="beforeSave"
            editDialogClass="sys-privilege-edit-dialog"
            :selectedDataArray.sync="selectedData"
            addSuccessMessages="新增用户成功"
            editSuccessMessages="编辑用户成功"
            deleteSuccessMessages="删除用户成功"
          >
            <template slot="result">
              <el-table-column type="selection" width="55">
              </el-table-column>
              <el-table-column type="index" :index="indexMethod" width="60" label="序号">
              </el-table-column>  
              <el-table-column sortable prop="username" label="员工ID">
              </el-table-column> 
              <el-table-column sortable prop="realname" label="姓名">
              </el-table-column> 
              <el-table-column sortable prop="departIds" label="部门">
              </el-table-column>
              <el-table-column sortable prop="medicalField" width="135">
                <template slot="header" slot-scope="scope">
                  <div style="display:inline-block">
                    <div>所在治疗领域</div>
                    <div>（franchise）</div>
                  </div>
                </template>
              </el-table-column>                       
              <el-table-column fixed="right" label="操作" width="110">
                <template slot-scope="scope">
                  <div class="table-column-operate">
                    <el-button type="text" @click="handleEditClick(scope.row)">
                      编辑
                    </el-button>
                    <el-button type="text" @click="handleDeleteClick(scope.row)">
                      删除
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </template>
            <template slot="customTitle">{{actionType=='add'?'新增用户':'用户信息'}}</template>
            <template slot="editForm">
                <el-row v-if="actionType=='add'">
                  <el-col :span="6">
                    <el-input placeholder="搜索AD账号" v-model="adSearchText">
                      <el-button slot="append" class="ad-search" @click="handleSearchAD()">搜索</el-button>
                    </el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                      <el-form-item required label="员工ID" prop="username">
                          <el-input disabled placeholder="搜索AD账号系统自动查询" v-model="addNewOrEditData.username"></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item label="姓名" prop="realname">
                        <el-input disabled placeholder="搜索AD账号系统自动查询" v-model="addNewOrEditData.realname"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item required label="部门" prop="departIds">
                        <el-select disabled multiple placeholder="搜索AD账号系统自动查询" v-model="addNewOrEditData.departIds">
                            <el-option v-for="item in baseDataRecords.Depart" :key="item.id" :value="item.id" :label="item.departName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item label="所在治疗领域（franchise）" prop="medicalField">
                        <el-select disabled multiple placeholder="搜索AD账号系统自动查询" v-model="addNewOrEditData.medicalField">
                            <el-option v-for="item in baseDataRecords.MedicalField" :key="item.id" :value="item.id" :label="item.medicalFieldName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item prop="allowDepartIds">
                        <span class="tooltip-header-text" slot="label">允许查看部门数据<common-tooltip tipCode="13"></common-tooltip></span>
                        <el-select multiple placeholder="请选择（可多选）" v-model="addNewOrEditData.allowDepartIds">
                            <el-option v-for="item in allowDeparts" :key="item.id" :value="item.id" :label="item.departName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
            </template>
            <template slot="confirmAddNewMessage">
              <div>
                <span>确认添加该用户？</span>
              </div>
            </template>
            <template slot="confirmEditMessage">
              <div>
                <span>确认保存该用户？</span>
              </div>
            </template>
            <template slot="confirmDeleteMessage">
              <div>
                <span>删除该用户？</span>
              </div>
            </template>
            <template slot="confirmBatchDeleteMessage">
              <div>
                <span>批量删除用户？</span>
              </div>
            </template>
          </common-crud>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import externalprivilege from '@/api/sysmanagement/externalprivilege';
import LeftBar from '../LeftBar';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    LeftBar
  },
  data() {
    return {
      privilegeData :[],
      searchData: {
      },
      addNewOrEditData: {
        username:'',
        realname: '',
        departIds: [],
        allowDepartIds: [],
        medicalField: [],
        roleIds: [],
      },
      crudApi: externalprivilege,
      selectedData: [],
      actionType: '',
      adSearchText: '',
      allowDeparts: []
    }
  },
  computed: {
    ...mapGetters(['userInfo','baseDataRecords','basedataGetName','basedataGetNameByRowIdField'])
  },
  methods: {
    ...mapActions(['initBaseDataByTypes']),
    formatDateTime2Date(row, column, cellValue, index) {
      return this.$refs['crud'].formatDateTime2Date(row, column, cellValue, index);
    },
    formatBaseData(row, column, cellValue, index) {
      if(column.property == 'roleIds'){
          if(row.roleIds) {
            let ids = row.roleIds;
            if(typeof ids == 'string') {
              ids =  ids.split(',');
            }
            let roleNames = []
            for (let pidIndex = 0; pidIndex < ids.length; pidIndex++) {
              roleNames.push(this.basedataGetName('Role', ids[pidIndex]));              
            }     
            return roleNames.join(',')       
          }
          return row.roleIds;
      }

      if(column.property == 'departIds'){
          if(row.departIds) {
            let ids = row.departIds;
            if(typeof ids == 'string') {
              ids =  ids.split(',');
            }
            let departNames = []
            for (let pidIndex = 0; pidIndex < ids.length; pidIndex++) {
              departNames.push(this.basedataGetName('Depart', ids[pidIndex]));              
            }     
            return departNames.join(',')       
          }
          return row.departIds;
      }

      if(column.property == 'medicalField'){
          if(row.medicalField) {
            let ids = row.medicalField;
            if(typeof ids == 'string') {
              ids =  ids.split(',');
            }
            let medicalFieldNames = []
            for (let pidIndex = 0; pidIndex < ids.length; pidIndex++) {
              medicalFieldNames.push(this.basedataGetName('MedicalField', ids[pidIndex]));              
            }     
            return medicalFieldNames.join(',')       
          }
          return row.medicalField;
      }
      
      return this.basedataGetNameByRowIdField(column.property, row);
    },    
    indexMethod(index) {
      return this.$refs['crud'].indexMethod(index);
    },handleSearch() {
      this.$refs['crud'].handleSearch(1);      
    },
    handleAddNewClick() {
      this.actionType = 'add'
      this.$refs['crud'].handleAddNew();
    },
    handleEditClick(item) {     
      this.actionType = 'edit'     
      if(typeof item.roleIds == 'string'){
        item.roleIds = item.roleIds.split(',');
      }     
      if(typeof item.departIds == 'string'){
        item.departIds = item.departIds.split(',');
      }   
      if(typeof item.medicalField == 'string'){
        item.medicalField = item.medicalField.split(',');
      }  
      if(typeof item.allowDepartIds == 'string'){
        item.allowDepartIds = item.allowDepartIds.split(',');
      }  
      this.$refs['crud'].handleEdit(item);
    },
    beforeSave(saveData) {          
      saveData.roleIds = saveData.roleIds.join(',');   
      saveData.departIds = saveData.departIds.join(',');  
      saveData.medicalField = saveData.medicalField.join(',');  
      saveData.allowDepartIds = saveData.allowDepartIds.join(',');
    },
    handleDeleteClick(item) {
      this.$refs['crud'].handleDelete(item);
    },
    handleBatchDeleteClick() {
      this.$refs['crud'].handleBatchDelete();
    },
    handlerExportExcelClick() {
      this.$refs['crud'].handlerExportExcel('用户权限.xlsx');
    },    
    handleUpdateSuccess() {
      this.handleSearch();
    },
    handleSearchAD() {
      externalprivilege.getEdcByAd({
              ad:this.adSearchText
            })
            .then(res => {
              if(res && res.username) {
                this.addNewOrEditData.username = res.username
                this.addNewOrEditData.realname = res.realname
                this.addNewOrEditData.departIds = res.departIds.split(',')
                this.addNewOrEditData.medicalField = res.medicalField.split(',')
              }
            })
    }
  },  
  mounted() {     
    this.initBaseDataByTypes(['SysErrorTip','Role','Depart','MedicalField'])
        .then(() => {
          externalprivilege.getAllowDeparts()
                .then(res => {
                  res.records.forEach(element => {
                    element.id = element.departId
                  });
                  this.allowDeparts = res.records;
                })
          this.handleSearch();  
        })
  }
};
</script>

<style lang="less" scoped>
  .search-content {
    display: flex;
    margin-bottom: 22px;

    .search-content-fields {
      width: 800px;

      .el-input {
        width: 200px;
      }

      .el-button {
        margin-top: 40px;
      }
    }
  }
  .operate {
    float: right;
    margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// index.vue?3358ec17